import { Tabs } from '@mantine/core';
import type { FC } from 'react';
import { useEffect, useMemo, useState } from 'react';
import HomePageSectionLessonTabList from '@/Module/HomePage/Component/HomePageSectionLesson/HomePageSectionLessonTabList';
import style from '@/Module/HomePage/Component/HomePageSectionLesson/mantineTabs.module.scss';
import { getLessonListByCategoryIdAction } from '@/Module/HomePage/Store/Action';
import { categoryLessonSectionListAll, categoryLessonSectionListId, categoryLessonSectionListIds } from '@/Module/HomePage/Store/Selector';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const HomePageSectionLessonTab: FC = () => {
  const categoryAll = useAppSelector(categoryLessonSectionListAll);
  const dispatch = useAppDispatch();
  const ids = useAppSelector(categoryLessonSectionListIds);
  const [activeId, setActiveId] = useState<number>(ids[6] as number);
  const categoryLesson = useAppSelector(state => {
    return categoryLessonSectionListId(state, activeId)?.lessonSectionList?.ids ?? [];
  });
  const defaultValue = useMemo(() => {
    return categoryAll.find(item => item.category.title === 'یازدهم')?.category.id as string;
  }, [categoryAll]);
  useEffect(() => {
    if (categoryLesson.length) return () => {};
    const promise = dispatch(getLessonListByCategoryIdAction({
      categoryCategoryId: activeId
    }));
    return () => {
      promise.abort();
    };
  }, [activeId, categoryLesson]);
  return <Tabs classNames={style} className="mt-8 flex flex-col overflow-hidden" defaultValue={defaultValue} aria-label="فیلم های آموزشی" unstyled onChange={value => setActiveId(Number(value))} data-sentry-element="Tabs" data-sentry-component="HomePageSectionLessonTab" data-sentry-source-file="HomePageSectionLessonTab.tsx">
      <Tabs.List aria-label="فیلم های آموزشی پایه" className="flex-noWrap flex overflow-y-scroll pb-2 text-center sm:flex-wrap sm:overflow-auto sm:pb-0" data-sentry-element="unknown" data-sentry-source-file="HomePageSectionLessonTab.tsx">
        {categoryAll.map(category => <Tabs.Tab key={category.category.id} value={category.category.id.toString()} aria-label={category.category.title ? `?? ${category.category.title}` : 'تب نامشخص'} aria-labelledby={category.category.title ? `?? ${category.category.title}` : 'تب نامشخص'}>
            {category.category.title}
          </Tabs.Tab>)}
      </Tabs.List>
      {categoryAll.map(category => <Tabs.Panel value={category.category.id.toString()} key={category.category.id}>
          <HomePageSectionLessonTabList ids={categoryLesson} activeId={activeId} />
        </Tabs.Panel>)}
    </Tabs>;
};
export default HomePageSectionLessonTab;